import React from 'react';
import { memoize } from 'lodash-es';
import loadable from '@loadable/component';
import hoistNonReactStatics from 'hoist-non-react-statics';

import reportError from 'ha/helpers/bugsnag/reportError';
import SomethingWentWrongPage from 'ha/pages/SomethingWentWrongPage';

export const createRouteComponent = (store, page) => {
  const PageInit = loadable.lib(() => import(`ha/pages/${page}/index.js`));

  return PageInit.load()
    .then(({ default: init }) => init(store))
    .then(PageComponent => {
      const Component = props => (
        <React.Fragment>
          {/* PageInit rendered to add bundles to initial html */}
          <PageInit />
          <PageComponent {...props} />
        </React.Fragment>
      );

      // hoist statics to make asyncConnect work
      hoistNonReactStatics(Component, PageComponent);

      return Component;
    })
    .catch(error => {
      reportError(error);

      return SomethingWentWrongPage;
    });
};

export default isServer => {
  // don't memoize on server side to avoid memory leaks
  const createRouteComponentEnhanced = isServer
    ? store => page => createRouteComponent(store, page)
    : memoize(store => memoize(page => createRouteComponent(store, page)));

  return store => page => (nextState, callback) => {
    createRouteComponentEnhanced(store)(page).then(Component =>
      callback(null, Component),
    );
  };
};
